import { Alert, Flex } from 'antd';
import { Link, Text } from 'components/mvp-typography';
import { paths } from 'routes';

export function PaymentsBlockedAlert() {
  return (
    <Flex align="center" vertical>
      <Alert
        showIcon
        type="error"
        message={
          <>
            <Text style={{ fontWeight: 'bold' }}>PAYMENTS BLOCKED</Text>
          </>
        }
        description={
          <>
            <Text>
              Your organisation does not have a payment method set up. You will
              not be able to purchase new assessments until this is complete.
            </Text>
            <Text style={{ fontWeight: 'bold' }}>
              <Link href={paths.clinician.billingSettings()}> View task</Link>
            </Text>
          </>
        }
        style={{
          maxWidth: 500
        }}
      />
    </Flex>
  );
}
